<template>
    <div class="confirm-modal">
        <div class="confirm-modal__title">
            <slot name="title">
                {{ title }}
            </slot>
        </div>

        <div class="confirm-modal__content">
            <slot></slot>
        </div>

        <div class="confirm-modal__footer">
            <UISimpleButton
                v-if="showCancelButton"
                button-type="outlined"
                @clicked="closeModal"
            >
                <slot name="cancel">
                    Отмена
                </slot>
            </UISimpleButton>

            <UISimpleButton
                :loading="confirmLoading"
                @clicked="onConfirmClick"
            >
                <slot name="confirm">
                    {{ confirmLabel }}
                </slot>
            </UISimpleButton>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { defineProps, defineEmits, ref, provide } from 'vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    const props = defineProps({
        title: {
            type: String,
            default: 'Подтвердите действие',
        },

        confirmLabel: {
            type: String,
            default: 'Подтвердить',
        },

        onConfirm: {
            type: Function,
            default: null,
        },

        showCancelButton: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits(['close']);

    const form = ref<object>({});
    const errors = ref<Record<string, string[]>>({});
    const confirmLoading = ref<boolean>(false);

    provide('form', form);
    provide('errors', errors);

    function closeModal(): void {
        emit('close');
    }

    function onConfirmClick(): void {
        confirmLoading.value = true;
        errors.value = {};

        function handleOnConfirmResult(result: any): void {
            // confirmLoading.value = false;

            errors.value = result === undefined ? {} : result;

            if (result === undefined) {
                closeModal();
            }
        }

        const confirmResult = typeof props.onConfirm === 'function' ? props.onConfirm(form.value) : undefined;

        if (confirmResult instanceof Promise) {
            confirmResult
                .then(handleOnConfirmResult)
                .finally(() => {
                    confirmLoading.value = false;
                });

            // confirmLoading.value = false;

            return;
        }

        handleOnConfirmResult(confirmResult);
    }
</script>

<style scoped lang="scss">
    @use './ConfirmActionModal.scss' as *;
</style>
